import { useAtom } from 'jotai';
import React, { useEffect, useRef } from 'react';
import { languageAtom } from '../atoms/languageAtom';
import { reservationText } from '../constants';

const Reservation = () => {
  const titleRef = useRef(null);
  const descRef = useRef(null);
  const [language] = useAtom(languageAtom);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          } else {
            entry.target.classList.remove('show');
          }
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(titleRef.current);

    const items = descRef.current.children;
    for (const item of Array.from(items)) {
      observer.observe(item);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="reservation" data-section="reservation">
      <div className="reservation__inner">
        <h2 className="reservation__title" ref={titleRef}>
          Reservation
        </h2>
        <div className="reservation__desc" ref={descRef}>
          {reservationText.map((text) => (
            <div key={text.title} className="reservation__desc__item">
              <h3>{text.title}</h3>
              {language === 'en' ? (
                <p dangerouslySetInnerHTML={{ __html: text.desc }} />
              ) : (
                <>
                  <h3 className="kr">{text.titleKr}</h3>
                  <p
                    className="kr"
                    dangerouslySetInnerHTML={{ __html: text.descKr }}
                  />
                </>
              )}
            </div>
          ))}

          {language !== 'en' ? (
            <>
              <div className="reservation__desc__item button-group">
                <a
                  className={'menu'}
                  rel="noreferrer"
                  href="https://app.catchtable.co.kr/ct/shop/tempmosuseoul"
                  target="_blank"
                  title="download Dinner pdf"
                >
                  예약 바로 가기
                </a>
              </div>

              <div className="reservation__desc__item button-group">
                <a
                  className={'menu'}
                  rel="noreferrer"
                  href="https://www.catchtable.net/shop/tempmosuseoul"
                  target="_blank"
                  title="download Dinner pdf"
                >
                  Reservation
                </a>
              </div>
            </>
          ) : (
            <>
              <div className="reservation__desc__item button-group">
                <a
                  className={'menu'}
                  rel="noreferrer"
                  href="https://app.catchtable.co.kr/ct/shop/tempmosuseoul"
                  target="_blank"
                  title="download Dinner pdf"
                >
                  Reservation for Korean
                </a>
              </div>

              <div className="reservation__desc__item button-group">
                <a
                  className={'menu'}
                  rel="noreferrer"
                  href="https://www.catchtable.net/shop/tempmosuseoul"
                  target="_blank"
                  title="download Dinner pdf"
                >
                  Reservation for Foreigner
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default Reservation;
